<div class="image-tool-wrapper" [ngStyle]="getContainerStyles()" #signatureContainerRef>
  <div *ngIf="!entity.content" class="empty-image-src">{{'BUILD.Signature' | translate}}</div>
</div>
